function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Stairs Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.92899157,10.3009667 L8.9623249,10.3009667 C9.23846728,10.3009667 9.4623249,10.077109 9.4623249,9.80096667 L9.4623249,5.76763333 L13.4956582,5.76763333 C13.7718006,5.76763333 13.9956582,5.54377571 13.9956582,5.26763333 L13.9956582,1.2343 L18.0289916,1.2343 C18.3051339,1.2343 18.5289916,1.01044237 18.5289916,0.7343 C18.5289916,0.458157625 18.3051339,0.2343 18.0289916,0.2343 L13.4956582,0.2343 C13.2195159,0.2343 12.9956582,0.458157625 12.9956582,0.7343 L12.9956582,4.76763333 L8.9623249,4.76763333 C8.68618253,4.76763333 8.4623249,4.99149096 8.4623249,5.26763333 L8.4623249,9.30096667 L4.42899157,9.30096667 C4.15284919,9.30096667 3.92899157,9.52482429 3.92899157,9.80096667 L3.92899157,13.8343 L1.02899157,13.8343 C0.752849195,13.8343 0.52899157,14.0581576 0.52899157,14.3343 C0.52899157,14.6104424 0.752849195,14.8343 1.02899157,14.8343 L4.42899157,14.8343 C4.70513394,14.8343 4.92899157,14.6104424 4.92899157,14.3343 L4.92899157,10.3009667 Z",
  id: "stairs-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "stairs-Icon/Global/Stairs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "stairs-Swatches/Midnight",
  transform: "translate(2.971008, 4.265700)"
}, /*#__PURE__*/React.createElement("use", {
  id: "stairs-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#stairs-path-1"
})));

var SvgStairs = function SvgStairs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStairs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stairs.d9562bbf.svg";
export { ForwardRef as ReactComponent };